import React, { ComponentType } from 'react';
import './mobileNavigation.module.scss';
import { inject, observer } from 'mobx-react';
import { HeaderLogo } from '../../components/atoms/Logo';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { EnhancedLocationDescriptor, V3Routes } from '../../routes';
import { routingStore } from '../../../common/stores/routing';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { IconHome } from './IconHome';
import { IconCourse } from './IconCourse';
import { HomeNavigationBackground } from '../../states/NavigationState';
import { CoachSkillCertificationState } from '../../states/CoachSkillCertificationState';
import { IconTimesheet } from './IconTimesheet';
import { Create } from '@material-ui/icons';
import { NotificationIcon } from './NotificationIcon';
import { SpUserInfo } from '../../../commonv3/components/organisms/navigation/SpUserInfo';
import { IconEvent } from './IconEvent';

type NavItemProps = {
  to: EnhancedLocationDescriptor;
  activeWhen: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any;
};

const NavItem = observer(({ to, activeWhen, children }: NavItemProps) => {
  const active = routingStore.location.pathname.match(activeWhen);
  return (
    <Link styleName={classNames('nav-item', { active: active })} to={to}>
      <div styleName="nav-item-inner">{children}</div>
    </Link>
  );
});

type Props = {
  background: HomeNavigationBackground;
  showMainMenu?: boolean;
};

type InternalProps = {
  coachSkillState: CoachSkillCertificationState;
};

const MobileNavigationInner = inject('coachSkillState')(
  observer(
    class MobileNavigationInner extends React.Component<Props & InternalProps> {
      render() {
        const currentUser = GlobalStatesV3.currentUser;
        const { background, showMainMenu, coachSkillState } = this.props;
        return (
          <div styleName={classNames('nav-wrapper', background)}>
            <div styleName="nav-top">
              <HeaderLogo onClick={() => GlobalStatesV3.routing.push('/')} />
              <div styleName="icons">
                <NotificationIcon />
                <SpUserInfo currentUser={currentUser} onClick={() => routingStore.push(V3Routes.myPage())} />
              </div>
            </div>
            <div styleName={classNames('nav-main', { hidden: !showMainMenu })}>
              <NavItem to={V3Routes.home()} activeWhen="^/?$|^/home/?$|^/home/reservations?$">
                <IconHome styleName="icon" /> ホーム
              </NavItem>
              <NavItem to={V3Routes.courses()} activeWhen={'^/courses/?|^/exam_'}>
                <IconCourse styleName="icon" />
                コース
              </NavItem>
              <NavItem to={V3Routes.userCourseWorkSubmissions()} activeWhen="^/course_work_submissions?">
                <Create styleName="icon" /> 課題
              </NavItem>
              <NavItem to={V3Routes.events()} activeWhen="/events/?">
                <IconEvent styleName="icon" /> イベント
              </NavItem>
              {coachSkillState.hasAnySkill && (
                <NavItem to={V3Routes.timesheetHome()} activeWhen="^/timesheet/?$">
                  <IconTimesheet styleName="icon" /> シフト
                </NavItem>
              )}
            </div>
          </div>
        );
      }
    }
  )
);

export const MobileNavigation = MobileNavigationInner as ComponentType<Props>;
